import { render, staticRenderFns } from "./BottomSearchBar.vue?vue&type=template&id=1005b4a6&"
import script from "./BottomSearchBar.vue?vue&type=script&lang=js&"
export * from "./BottomSearchBar.vue?vue&type=script&lang=js&"
import style0 from "./BottomSearchBar.vue?vue&type=style&index=0&id=1005b4a6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports